/**
 * Labstep
 *
 * @module core/TableSimple
 * @desc Component that provides simplifed API for rendering tables by providng row and column functions
 */

import { TableSimpleBody } from 'labstep-web/core/Table/Simple/Body';
import { TableSimpleHeader } from 'labstep-web/core/Table/Simple/Header';
import type React from 'react';
import { Table } from 'semantic-ui-react';
import type { TableSimpleProps } from './types';

export const TableSimple: React.FC<TableSimpleProps> = ({
  columns,
  rows,
  hideHeader,
  footer,
  selectedRowI,
  dataCy,
  ...rest
}) => (
  <Table fixed data-cy={dataCy} {...rest}>
    {!hideHeader && <TableSimpleHeader columns={columns} />}
    <TableSimpleBody
      columns={columns}
      rows={rows}
      footer={footer}
      selectedRowI={selectedRowI}
    />
  </Table>
);
